import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { MicrocopyContext } from '../context/microcopy.context';

export const ifWordLetterLowercase = (str) => {
  const regex = /\b(if)\b/gi;
  const uppercaseSentence = str.toUpperCase().replace(regex, 'iF');
  return uppercaseSentence;
};

export const ifDesignFixCase = (str, toUpper) => {
  const cased = toUpper ? str.toUpperCase() : str;
  return cased.replace(/(if)(design)/gi, 'iF$2');
};

export const getFormattedEmployeeAmount = (amount) => {
  if (amount <= 10) {
    return '1-10';
  }
  if (amount <= 50) {
    return '11-50';
  }
  if (amount <= 100) {
    return '51-100';
  }
  if (amount <= 500) {
    return '101-500';
  }
  if (amount <= 1000) {
    return '501-1000';
  }
  if (amount <= 5000) {
    return '1001-5000';
  }
  return '> 5000';
};

export const getCopy = (key, dictionary) =>
  (dictionary && dictionary[key]) || key;

export const getCopyWithFallback = (key, dictionary, fallback) => {
  const copy = getCopy(key, dictionary);

  return copy === key ? fallback : copy;
};

export const withMicrocopy = (Component, locale) => (props) => {
  const { allContentfulMicrocopy } = useStaticQuery(
    graphql`
      query {
        allContentfulMicrocopy {
          nodes {
            key
            value
            node_locale
          }
        }
      }
    `
  );

  const microcopy = allContentfulMicrocopy.nodes
    .filter((node) => node.node_locale === locale)
    .reduce((acc, curr) => {
      return {
        ...acc,
        [curr.key]: curr.value,
      };
    }, {});
  return (
    <MicrocopyContext.Provider value={microcopy}>
      <Component />
    </MicrocopyContext.Provider>
  );
};

// transform from camelCase to spaced and uppercase
export const formatFilterLabel = (label, activeCount) => {
  const rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
  const newLabel = label.replace(rex, '$1$4 $2$3$5').toUpperCase();
  return activeCount > 0 ? `${newLabel} (${activeCount})` : newLabel;
};
